import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Tile } from '@emi/shared/models';
import { Constants } from './constants';
import { InfographicsModalComponent } from '@emi/shared/infographics';

@Component({
    selector: 'via-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
    public searchDescription = Constants.SEARCH_DESCRIPTION;
    public tiles: Array<Tile> = [
        // tslint:disable-next-line: max-line-length
        {
            title: 'Search',
            icon: 'far fa-search',
            description: 'Search for SKU data from Suppliers, Brands, Retailers, or Attributes across multiple countries and categories.',
            buttonLabel: 'LEARN MORE',
            infographicsName: 'search',
        },
        // tslint:disable-next-line: max-line-length
        {
            title: 'Export',
            icon: 'far fa-gears',
            description:
                'Filter, configure and export via SKU data like price history, availability, and average ratings in an easy to download CSV format.',
            buttonLabel: 'LEARN MORE',
            infographicsName: 'export',
        },
        // tslint:disable-next-line: max-line-length
        // {
        //     title: 'Insights',
        //     icon: 'far fa-chart-line',
        //     description:
        //         'Explore curated Via data stories for online product assortment, attributes, availability, prices, promotions and ratings.',
        //     buttonLabel: 'LEARN MORE',
        //     infographicsName: 'insights',
        // },
    ];

    constructor(public dialog: MatDialog) {}

    public openInfographicsModal(infographicsName: string | undefined): void {
        if (infographicsName) {
            this.dialog.open(InfographicsModalComponent, {
                data: infographicsName,
                panelClass: 'e-infographics-modal',
            });
        }
    }
}
